import { Box, Typography, Grid } from "@mui/material";

import LinearProgress from "@mui/material/LinearProgress";

const UploadFileProgress = ({ fileName, perc }) => {
    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1 }} justifyContent={'center'} alignItems={'center'}>
            <Typography variant={'h4'} sx={{textAlign:'center'}}>{fileName}</Typography>
            <Box sx={{ width: '100%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ width: '100%', mr: 1 }}>
                        <LinearProgress variant="determinate" value={perc} color={'primary'} sx={{ height: '20px' }} />
                    </Box>
                    <Box sx={{ minWidth: 35 }}>
                        <Typography
                            variant="h4"
                            sx={{ color: 'text.secondary' }}
                        >{`${perc}%`}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default UploadFileProgress;